import { render, staticRenderFns } from "./goodsInquiryRecords.vue?vue&type=template&id=13cd9352&scoped=true&"
import script from "./goodsInquiryRecords.vue?vue&type=script&lang=js&"
export * from "./goodsInquiryRecords.vue?vue&type=script&lang=js&"
import style0 from "./goodsInquiryRecords.vue?vue&type=style&index=0&id=13cd9352&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13cd9352",
  null
  
)

export default component.exports